// deps
import React, { memo, ReactElement, useCallback } from "react";

// internal-deps
import { BottomSheet, BottomSheetChildrenProps, Spinner } from "@swiggy-private/core-ui";
import { isNonEmptyString } from "@swiggy-private/payment-core";

// styles
import styles from "./HalfCardLoader.scss";

interface Props {
    title?: string;
    onClose?: VoidFunction;
    loaderBgSrc?: string;
}

function HalfCardLoader(props: Props): ReactElement {
    const { title, onClose, loaderBgSrc } = props;

    const _onClose = useCallback((): void => {
        if (onClose != null && typeof onClose === "function") {
            onClose();
        }
    }, [onClose]);

    return (
        <BottomSheet hideOnOverlayClick={false} onClose={_onClose}>
            {(_: BottomSheetChildrenProps): React.ReactElement => (
                <div className={styles.container}>
                    {isNonEmptyString(title) && <div className={styles.containerTitle}>{title}</div>}
                    <Spinner spinnerBgImgSrc={loaderBgSrc} containerClass={styles.containerLoader} />
                </div>
            )}
        </BottomSheet>
    );
}

export default memo(HalfCardLoader);
